import {combineReducers} from "@reduxjs/toolkit";
import {createMenuReducer} from "./createMenuSlice";
import {menuManagementReducer} from "./menumanagement/menuManagementSlice";
import {menuEditorPageReducer} from "./menuEditorPageSlice";

export const menuReducer = combineReducers({
    create: createMenuReducer,
    management: menuManagementReducer,
    editorPage: menuEditorPageReducer
});
